import React, { useContext, useEffect, useState } from "react";
import SellersSelectionComponent from "./SellersSelectionComponent";
import { IMainContext, SETTINGS_TABLE_DATA_TYPE, TBrandsData, TSellersData } from "@ts/common-types";
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { mainContext } from "@/ts/constants";
import { usePermissionCheck } from "@/hooks/AllCustomHooks";
interface ISellers {
    isLoading: boolean;
    listData: TSellersData[] | TBrandsData[];
    selectedDatalist: string[] | number[];
    title?: SETTINGS_TABLE_DATA_TYPE;
}

const AddSellersToBuybox: React.FC<ISellers> = ({
    isLoading,
    listData,
    selectedDatalist,
    title,
}) => {
    const { cerbosPermissions } = useContext<IMainContext>(mainContext);

    const sortData = (data: TSellersData[] | TBrandsData[]) => {
        if (title) {
            // For brands data
            const brandsData = data as TBrandsData[];
            const selected = brandsData.filter(item => item.is_selected).sort((a, b) => a.tag_name.localeCompare(b.tag_name));
            const unselected = brandsData.filter(item => !item.is_selected).sort((a, b) => a.tag_name.localeCompare(b.tag_name));
            return [...selected, ...unselected];
        } else {
            // For sellers data
            const sellersData = data as TSellersData[];
            const selected = sellersData.filter(item => item.isPreferredSeller).sort((a, b) => a.seller_name.localeCompare(b.seller_name));
            const unselected = sellersData.filter(item => !item.isPreferredSeller).sort((a, b) => a.seller_name.localeCompare(b.seller_name));
            return [...selected, ...unselected];
        }
    };

    const [filteredSellersData, setFilteredSellersData] = useState(() => sortData(listData));

    useEffect(() => {
        setFilteredSellersData(sortData(listData))
    }, [listData, title])

    const onSearch = (searchValue: string) => {
        if(title){
            const matchingOptions = (listData as TBrandsData[]).filter((data) => {
                return data.tag_name.includes(searchValue);
            })
            setFilteredSellersData(sortData(matchingOptions))
        }else {
            const matchingOptions = (listData as TSellersData[]).filter((data) => {
                return data.seller_name.includes(searchValue);
            })
            setFilteredSellersData(sortData(matchingOptions))
        }
    }

    const { canUpdateSettings } = usePermissionCheck();

    return (
        <>
            <div className={`buy-box-container ${!canUpdateSettings ? "pe-none opacity-50" : ""} ${title ? "mt-5" : ""}`}>
                <label className="settings-timezone-header">{title || "Buy Box"}</label>
                <div className="d-flex justify-content-end" style={{ marginTop: "5px", width: "749px" }}>
                    <Input onChange={(val) => {
                        onSearch(val.target.value)
                    }} placeholder={`Search ${title || "Sellers"}`} className="border shadow-sm" style={{ width: "230px", backgroundColor: "white" }} bordered={false} suffix={<SearchOutlined />} />
                </div>
                <div className="card shadow p-3" id="sellers-container">
                    <SellersSelectionComponent
                        {...{ isLoading, filteredSellersData, title }}
                    />
                </div>
                {listData.length >= 1 ? (
                    <div className="text-danger sellers-count">
                        Total {title || "sellers"} selected:{" "}
                        <span className="text-dark">
                            {selectedDatalist.length}
                        </span>
                    </div>
                ) : null}
            </div>
        </>
    );
};

export default AddSellersToBuybox;
